/* eslint class-methods-use-this: 0 */
import CollectionApi from 'client/api/v2/CollectionApi';

class PolicyTemplateApi extends CollectionApi {
  constructor() {
    super('/api/v2/policytemplates', {
      skip: 0,
      limit: 100,
      sort: 'display_name',
      filter: [{
        name: 'display_name',
        operator: 'search',
        value: '',
      }],
    });
  }

  findPolicyTemplatesByField(field, vals, params = {}) {
    const {
      skip = null,
      limit = 50,
      sort = null,
      searchTerm = null,
    } = params;
    return this.fetch(skip, limit, sort, searchTerm, null, [{
      name: field,
      operator: 'in',
      value: vals.join('|'),
    }]);
  }

  findPolicyTemplatesByName(names, params = {}) {
    return this.findPolicyTemplatesByField('name', names, params);
  }

  findPolicyTemplatesById(ids, params = {}) {
    return this.findPolicyTemplatesByField('id', ids, params);
  }

  /**
   * Overriding this parent's method in order to ignore the category filter since that's being
   * done in the UI side entirely. See https://jumpcloud.atlassian.net/browse/AL-1046.
   * @param params
   * @param filters
   * @param searchTerm
   * @returns {string}
   */

  setFilterTerm(params, filters = [], searchTerm) {
    const searchFilter = [];

    if (searchTerm && params.filter) {
      const filter = params.filter.find(f => f.operator === 'search');

      if (filter) {
        searchFilter.push({ ...filter, ...{ value: searchTerm } });
      }
    }

    return filters
      .concat(searchFilter)
      .reduce((acc, filter) => {
        const { name, operator, value } = filter;

        if (value !== '' && name !== 'category') {
          acc.push(`${name}:${operator}:${value}`);
        }

        return acc;
      }, [])
      .join(',') || '';
  }
}

export default new PolicyTemplateApi();
